module.exports = ".order-price {\n  margin: 10px 0; }\n  .order-price__title {\n    font-size: 15px; }\n  .order-price__price {\n    color: #0081C9;\n    font-size: 21px;\n    margin: 10px 0; }\n  .order-price__info {\n    font-size: 12px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/modal/service-order-modal/service-order-modal.component.scss
// module id = ./src/app/view/modal/service-order-modal/service-order-modal.component.scss
// module chunks = main